import React from "react"
import {Route, BrowserRouter as Router, Routes} from "react-router-dom"
import {QueryClient, QueryClientProvider} from "react-query"
import {ToastContainer, Slide} from "react-toastify"
import moment from "moment"
import "moment/dist/locale/sr"
import {Auth} from "auth/Auth"
import AuthRoute from "auth/AuthRoute"
import AdminRoute from "auth/AdminRoute"
import MainLayout from "layouts/MainLayout"
import RedLayout from "layouts/RedLayout"
import NotFound from "layouts/NotFound"
import HomePage from "pages/home/HomePage"
import AdminPage from "pages/admin/AdminPage"
import Login from "components/login/Login"
import Reset from "components/login/Reset"
import SearchPage from "pages/search/SearchPage"
import RescuerProfilePage from "pages/rescuer/RescuerProfilePage"
import ShiftPage from "pages/shift/ShiftPage"
import ReportPage from "pages/report/ReportPage"
import ReportReviewPage from "pages/report/ReportReviewPage"
import HandbooksPage from "pages/handbooks/HandbooksPage"
import NewRescuerPage from "pages/rescuer/NewRescuerPage"
import RescuerEditPage from "pages/rescuer/RescuerEditPage"
import ShiftApplicationsPage from "pages/shift/applications/ShiftApplicationsPage"
import ShiftTimelinePage from "pages/shift/timeline/ShiftTimelinePage"
import ShiftRosterPage from "pages/shift/roster/ShiftRosterPage"
import RescuePage from "pages/rescue/RescuePage"
import AnalyticsPage from "pages/analytics/AnalyticsPage"
import WikiPage from "pages/wiki/WikiPage"
import ErrorBoundary from "components/ErrorBoundary"
import ReloadPrompt from "components/common/ReloadPrompt"
import "react-toastify/dist/ReactToastify.css"
import "nprogress/nprogress.css"
import "styles/app.css"

const queryClient = new QueryClient()
moment.locale('rs')

export default function App() {

    return <QueryClientProvider client={queryClient}>
        <ToastContainer position="bottom-center" autoClose={2500} hideProgressBar newestOnTop closeOnClick pauseOnFocusLoss={false} draggable pauseOnHover theme="dark" transition={Slide}/>
        <ReloadPrompt />
        <ErrorBoundary>
            <Auth>
                 <Router>
                     <Routes>
                         <Route element={<MainLayout/>}>
                             <Route index element={<AuthRoute><HomePage/></AuthRoute>}/>
                             <Route path="/admin" element={<AdminRoute><AdminPage/></AdminRoute>}/>
                             
                             <Route path="/rescuers/" element={<AuthRoute><SearchPage/></AuthRoute>}/>
                             <Route path="/rescuers/:q" element={<AuthRoute><SearchPage/></AuthRoute>}/>
                             <Route path="/rescuer/new" element={<AdminRoute><NewRescuerPage/></AdminRoute>}/>
                             <Route path="/rescuer/:username" element={<AuthRoute><RescuerProfilePage/></AuthRoute>}/>
                             <Route path="/rescuer/:username/edit" element={<AuthRoute><RescuerEditPage/></AuthRoute>}/>
                             <Route path="/rescues/" element={<AuthRoute><SearchPage/></AuthRoute>}/>
                             <Route path="/rescues/:q" element={<AuthRoute><SearchPage/></AuthRoute>}/>
                             <Route path="/search" element={<AuthRoute><SearchPage/></AuthRoute>}/>                         
                             <Route path="/search/:q" element={<AuthRoute><SearchPage/></AuthRoute>}/>
                             
                             <Route path="/shift" element={<AuthRoute><ShiftPage/></AuthRoute>}/>
                             <Route path="/report" element={<AuthRoute><ReportPage/></AuthRoute>}/>
                             <Route path="/report/:area" element={<AuthRoute><ReportPage/></AuthRoute>}/>
                             <Route path="/report/:area/:date" element={<AuthRoute><ReportPage/></AuthRoute>}/>
                             <Route path="/report/:area/:date/review" element={<AuthRoute><ReportReviewPage/></AuthRoute>}/>
                             <Route path="/analytics" element={<AuthRoute><AnalyticsPage/></AuthRoute>}/>
                             <Route path="/handbooks" element={<AuthRoute><HandbooksPage/></AuthRoute>}/>
                             <Route path="/apply" element={<AuthRoute><ShiftApplicationsPage/></AuthRoute>}/>
                             <Route path="/roster" element={<AuthRoute><ShiftRosterPage/></AuthRoute>}/>
                             <Route path="/timeline" element={<AuthRoute><ShiftTimelinePage/></AuthRoute>}/>
                             <Route path="/rescue/:id" element={<AuthRoute><RescuePage/></AuthRoute>}/>
                             <Route path="/rescue" element={<AuthRoute><RescuePage/></AuthRoute>}/>
                             <Route path="/wiki/:page" element={<AuthRoute><WikiPage/></AuthRoute>}/>
                             <Route path="/faq" element={<AuthRoute><WikiPage page="faq"/></AuthRoute>}/>
                         </Route>
                         <Route element={<RedLayout/>}>
                             <Route path="/login" element={<Login/>}/>
                             <Route path="/reset" element={<Reset/>}/>
                         </Route>
                         <Route path="*" element={<NotFound/>}/>         
                     </Routes>                        
                 </Router>
            </Auth>
        </ErrorBoundary>
    </QueryClientProvider>

}
